import { CSSProperties, ElementType, useEffect } from "react"
import { css, cx } from "@emotion/css"
import { DragOverlay } from "@dnd-kit/core"
import { DraggingRowRendererProps } from "../types"
import { createPortal } from "react-dom"

export type SortableOverlayProps = {
  activeId?: string | null
  draggingRow: ElementType<DraggingRowRendererProps>
  cssVariables: CSSProperties
}
export function SortableOverlay(props: SortableOverlayProps) {
  const { activeId, draggingRow, cssVariables } = props

  return createPortal(
    <DragOverlay
      zIndex={31}
      style={{
        ...cssVariables,
        left: `var(--container-left)`,
        width: `var(--container-width)`,
      }}
    >
      {activeId ? (
        <ActiveDragItem id={activeId} draggingRow={draggingRow} />
      ) : null}
    </DragOverlay>,
    document.body,
  )
}

type ActiveDragItemProps = {
  id: string
  draggingRow: ElementType<DraggingRowRendererProps>
}
function ActiveDragItem(props: ActiveDragItemProps) {
  const { id, draggingRow: Content } = props
  useEffect(() => {
    document.body.style.cursor = "grabbing"
    document.body.style.userSelect = "none"
    return () => {
      document.body.style.cursor = ""
      document.body.style.userSelect = ""
    }
  }, [])

  return (
    <div
      className={cx(css`
        height: var(--row-height);
        background-color: #fff;
        z-index: 32;
        width: fit-content;
        /* max-width: 40vw; */
        box-shadow:
          inset 1px 0 0 #dadce0,
          inset -1px 0 0 #dadce0,
          0 1px 2px 0 rgb(60 64 67 / 30%),
          0 1px 3px 1px rgb(60 64 67 / 15%);
      `)}
    >
      <div
        className={cx(css`
          height: var(--row-height);
          background-color: #fff;
          /* max-width: 40vw; */
          width: var(--container-width);
          min-width: 200px;
        `)}
      >
        <Content id={id} />
      </div>
    </div>
  )
}
